<script setup lang="ts">
defineProps({
  hideText: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['onClick'])
</script>

<template>
  <div
    class="align-center border border-md border-primary d-inline-flex rounded my-3 cursor-pointer bg-white"
    @click="$emit('onClick')"
  >
    <div class="bg-primary pa-1">
      <VIcon
        icon="mdi-play-circle-outline"
        size="x-large"
      />
    </div>
    <div
      v-if="!hideText"
      class="mx-2 text-center text-body-2 text-primary"
    >
      {{ $t('actions.watch_tutorial') }}
    </div>
  </div>
</template>
